import {AnimatedKeyNumbersLazy} from 'app/components/animatedKeyNumbers/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineAnimatedKeyNumbers(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-animated-key-numbers')) {
        return;
    }

    class GemAnimatedKeyNumbers extends WebComponentLoader {
        reactLazyComponent = AnimatedKeyNumbersLazy;
    }

    customElements.define('gem-animated-key-numbers', GemAnimatedKeyNumbers);
}
